import { Component, computed, EventEmitter, inject, Input, Output, TemplateRef, ViewEncapsulation } from '@angular/core';
import { EnpsComponent } from '@common/components/base/enps-component';
import { TileColumn } from '@common/data-models/misc/tile-column';
import { NomWebServicesJson } from '@common/services/nom-web-services-json';
import { VisualStateService } from '@common/services/visual-state-service';
import { Store } from '@ngrx/store';
import { TileDay } from '@src/suite/common/data-models/misc/tile-day';
import { GlobalTablesService } from '@src/suite/common/services/global-tables-service';
import { LanguageSettings } from '@src/suite/common/services/language-settings';
import { selectHasAssignmentCostFields, selectHasTopicCostFields } from '@src/suite/common/store/global-tables/global-tables.selectors';
import { selectGroupedSortedTopics, selectTileItemSize } from '@src/suite/common/store/playbook/playbook.selector';
import { AppService } from '@suite/app.service';
import { map } from 'rxjs';

@Component({
    selector: 'st-tile-column',
    templateUrl: './tile-column.html',
    styleUrls: ['./tile-column.scss'],
    encapsulation: ViewEncapsulation.None,
    host: {
        class: 'st-tile-column',
    },
})
export class TileColumnComponent extends EnpsComponent {
    private store = inject(Store);
    groupedSortedTopics = this.store.selectSignal(selectGroupedSortedTopics);
    hasCostPropForTopics = this.store.selectSignal(selectHasTopicCostFields);
    hasCostPropForAssignments = this.store.selectSignal(selectHasAssignmentCostFields);
    groups$ = this.store.select(selectGroupedSortedTopics);

    itemSize$ = this.store.select(selectTileItemSize);

    records$ = this.groups$.pipe(
        map(groups => {
            if (groups) {
                const key = (<TileColumn>this.column).value;
                const entries = groups.entries[key];
                return (
                    entries?.map(entry => {
                        return {
                            ...entry,
                            uniqueId: `${key}-${entry.Guid}`,
                        };
                    }) || []
                );
            }
            return null;
        })
    );

    totalCost = computed(() => {
        return this.groupedSortedTopics().totalCost[this.column.value];
    });

    @Input() public objectName: string = '';
    @Input() public childObjectName: string = '';
    @Input() public column: TileDay | TileColumn;
    @Input() public itemTemplate: TemplateRef<any>;
    @Input() public totalCols: number = 0;
    @Output() public createTopic: EventEmitter<void> = new EventEmitter();

    public parentCostProps = [];
    private childCostProps = [];
    public costView: boolean = true;

    public getDragData(record, column): any {
        return {
            guid: record?.Guid,
            group: column,
        };
    }

    constructor(
        public appService: AppService,
        public globalTablesService: GlobalTablesService,
        public nomWebServicesJson: NomWebServicesJson,
        public visualStateService: VisualStateService,
        public languageSettings: LanguageSettings
    ) {
        super();
    }

    get costVisible(): boolean {
        const isSuperVisor = this.nomWebServicesJson?.HelloResults?.Supervisor;
        const readPriv = this.globalTablesService.securityPrivileges[this.nomWebServicesJson.PSTGroup].cost.read;

        return this.hasCostPropForTopics() && (isSuperVisor || readPriv);
    }

    trackByGuid(record) {
        return record.Guid;
    }
}
